import { render, staticRenderFns } from "./LayoutRootHub.vue?vue&type=template&id=67b0de75&"
import script from "./LayoutRootHub.vue?vue&type=script&lang=js&"
export * from "./LayoutRootHub.vue?vue&type=script&lang=js&"
import style0 from "./LayoutRootHub.vue?vue&type=style&index=0&id=67b0de75&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports